$('.event-slider').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse
  infinite: true,//スライドをループさせるかどうか。初期値はtrue
  slidesToShow: 3,//スライドを画面に2枚見せる
  slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
  arrows: false,//左右矢印の表示
  dots: false,//下部ドットナビゲーションの表示
  pauseOnHover: true,//マウスオーバー時スライドを停止
  pauseOnFocus: true,//フォーカス時スライドを停止
  responsive: [
    {
      breakpoint: 990,//551～989px以下の見せ方
      settings: {
        slidesToShow: 2,//スライドを画面に1枚見せる
        slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
      },
      },
    {
      breakpoint: 550,//549px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1枚見せる
        slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
      },
      },
  ]
});